"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var getPath = exports.getPath = function getPath(article, breadcrumbs, defaultPath) {
	if (!article || !article.art_id || !article.articleCategories.length > 0) {
		return defaultPath;
	}

	var defaultArticleCategory = article.articleCategories.find(function (x) {
		return x.default_flg;
	}) || article.articleCategories[0];
	var breadcrumbItem = breadcrumbs.data[defaultArticleCategory.category.cat_id];

	if (breadcrumbItem) {
		return breadcrumbItem[breadcrumbItem.length - 1].linkFriendlyName;
	}

	return defaultPath;
};